import React, { useState } from "react";
import { CheckIcon } from "@heroicons/react/24/outline";
import { Popover } from "@headlessui/react";

const EditableCell = ({
  value,
  id,
  field,
  onSave,
  type = "text",
  maxLength = 10,
  className = "w-full",
  inputClassName = "w-full px-2 py-1 border border-gray-300 rounded-md text-sm font-medium text-gray-900 text-center",
  displayClassName = "block w-full px-2 py-1 text-sm font-medium text-gray-900 text-left",
}) => {
  const [isEditing, setIsEditing] = useState(false);
  const [inputValue, setInputValue] = useState(value === "————" ? "" : value);

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleSave();
    }
  };

  const handleSave = () => {
    onSave({ id, field, value: inputValue });
    setIsEditing(false);
  };

  const formatDisplayValue = (val) => {
    if (!val) return "————";
    const strVal = val.toString();
    return strVal.length > maxLength
      ? `${strVal.slice(0, maxLength)}...`
      : strVal;
  };

  return (
    <div className="flex items-center  space-x-2 cursor-pointer">
      <div
        onDoubleClick={() => {
          setInputValue(value === "————" ? "" : value);
          setIsEditing(true);
        }}
        className="relative"
      >
        {isEditing ? (
          <input
            type={type}
            className={inputClassName}
            value={inputValue}
            onChange={(e) => setInputValue(e.target.value)}
            autoFocus
            onKeyDown={handleKeyDown}
            onBlur={(e) => {
              if (e.relatedTarget?.tagName === "BUTTON") return;
              setTimeout(() => {
                // If inputValue is empty or whitespace, save as ''
                const valToSave =
                  inputValue && inputValue.trim() !== "" ? inputValue : "";
                onSave({ id, field, value: valToSave });
                setIsEditing(false);
              }, 100);
            }}
            onFocus={(e) => {
              // Only select if not triggered by a paste
              if (!e.target.dataset.paste) {
                e.target.select();
              }
              delete e.target.dataset.paste; // reset flag
            }}
            onPaste={(e) => {
              e.target.dataset.paste = true;
            }}
            style={{ width: "100%", minWidth: "120px" }}
          />
        ) : (
          <div className="relative">
            <span
              className={`${displayClassName} cursor-pointer rounded px-1 group relative block h-full`}
            >
              <span className="hover:bg-gray-100 rounded inline-block w-full text-center ">
                {formatDisplayValue(value)}
                <div className="absolute z-10  w-40 bg-white text-gray-700 text-sm rounded-lg shadow-xl border border-gray-200 p-1 mt-2 left-0 bottom-0 transform -translate-x-1/2 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all duration-75 pointer-events-none">
                  <div className="break-words text-xs whitespace-normal">
                    {value}
                    <div className="text-xs text-gray-500 mt-1 pt-1 border-t border-gray-100">
                      Double click to edit
                    </div>
                  </div>
                </div>
              </span>
              <div className="absolute -top-1 -right-1 w-0.5 h-0.5 bg-blue-500 rounded-full"></div>
            </span>
          </div>
        )}
      </div>
      {isEditing && (
        <button
          onClick={handleSave}
          className="p-1 text-gray-400 hover:text-gray-600"
        >
          <CheckIcon className="h-5 w-5" />
        </button>
      )}
    </div>
  );
};

export default EditableCell;
